import { useEffect, useState } from 'react';
import { api } from '../../services/api';
import type { SaldoResumo, TipoEmissao } from './types';

/**
 * Saldo do próprio cooperado, para a pílula do header.
 *
 * `null` = pós-pago (a rota nunca falha por isto — `GET /api/cooperado/creditos/saldo`
 * sempre devolve `prePago`; a pílula simplesmente não aparece quando `prePago === false`).
 * `undefined` = ainda carregando.
 */
export function useSaldoResumo() {
  const [saldo, setSaldo] = useState<SaldoResumo | null | undefined>(undefined);
  // `undefined` = carregando. Guardado à parte porque `saldo` é null no
  // pós-pago, e antes a resposta inteira era descartada nesse caso — o shell
  // ficava sem saber o tipo, que é justamente o que decide a quarta aba.
  const [tipoEmissao, setTipoEmissao] = useState<TipoEmissao | undefined>(undefined);
  const [erro, setErro] = useState<string | null>(null);

  const recarregar = () => {
    setErro(null);
    api.get<SaldoResumo>('/cooperado/creditos/saldo')
      .then(res => {
        setSaldo(res.data.prePago ? res.data : null);
        setTipoEmissao(res.data.tipoEmissao ?? null);
      })
      .catch(() => {
        setErro('Não foi possível carregar o saldo');
        // Sem resposta não há tipo; `null` cai em Faturas, que é o caso de 195
        // dos 199 — e uma aba de fatura vazia informa, enquanto uma de crédito
        // vazia confunde (é o defeito que esta spec corrige).
        setTipoEmissao(null);
      });
  };

  useEffect(recarregar, []);

  return { saldo, tipoEmissao, erro, recarregar };
}
